/* eslint-disable consistent-return */
import { useEffect } from 'react';

type THubSpotScriptProps = {
    shouldLoadScript: boolean;
}

export default function HubSpotScript({
    shouldLoadScript,
}: THubSpotScriptProps): null {

    useEffect(() => {
        if (!shouldLoadScript || !process.env.HUBSPOT_ID) return;

        // Prevent duplicate script injection
        if (document.getElementById('hs-script-loader')) return;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'hs-script-loader';
        script.async = true;
        script.defer = true;
        script.src = `//js-eu1.hs-scripts.com/${process.env.HUBSPOT_ID}.js`;
        document.body.appendChild(script);

        // Cleanup on logout or component unmount
        return () => {
            if (script.parentNode) script.parentNode.removeChild(script);
        };
    }, [shouldLoadScript]);

    return null;
}
